var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5154 66.3869H10.6099C5.66285 66.3869 1.61523 62.3393 1.61523 57.3922V9.9001C1.61523 4.95301 5.66285 0.905396 10.6099 0.905396H54.5154C59.4625 0.905396 63.5101 4.95301 63.5101 9.9001V57.3922C63.5101 62.3393 59.4625 66.3869 54.5154 66.3869Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6514 26.4841H54.9649",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6514 13.7228H54.9649",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9649 39.2341H24.3491",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9649 51.9954H24.3491",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5264 31.5773C26.8663 31.5773 32.0059 26.4378 32.0059 20.0978C32.0059 13.7579 26.8663 8.61835 20.5264 8.61835C14.1864 8.61835 9.04688 13.7579 9.04688 20.0978C9.04688 26.4378 14.1864 31.5773 20.5264 31.5773Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5851 20.8737H19.7505",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7505 20.8736V15.0496",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56326 39.3577C8.79937 39.8525 9.14792 40.2572 9.44024 40.5833C9.99117 41.1904 10.6096 41.7301 11.2167 42.2473C11.5428 42.5284 11.8688 42.8095 12.1724 43.0906C12.3748 43.2817 12.5996 43.3716 12.8245 43.3716C13.0494 43.3716 13.2855 43.2704 13.4991 43.0793C14.095 42.5396 14.6909 42.0112 15.2868 41.4715C15.9052 40.9093 16.3662 40.4146 16.7372 39.9199C17.1757 39.3128 17.3668 38.6494 17.2994 37.9411C17.2207 37.1878 16.8496 36.6031 16.2088 36.2658C15.0619 35.6587 13.724 35.7824 12.802 36.5357C12.0937 35.951 11.2055 35.7486 10.2273 35.9622C9.51895 36.1197 9.01299 36.4345 8.67569 36.9179C8.48456 37.1878 8.40585 37.4801 8.34963 37.7162L8.32715 38.5932L8.34963 38.7618C8.41709 38.953 8.47331 39.1554 8.56326 39.3577Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56326 52.5125C8.79937 53.0072 9.14792 53.412 9.44024 53.7381C9.99117 54.3452 10.6096 54.8849 11.2167 55.4021C11.5428 55.6832 11.8688 55.9643 12.1724 56.2453C12.3748 56.4365 12.5996 56.5264 12.8245 56.5264C13.0494 56.5264 13.2855 56.4252 13.4991 56.2341C14.095 55.6944 14.6909 55.166 15.2868 54.6263C15.9052 54.0641 16.3662 53.5694 16.7372 53.0747C17.1757 52.4676 17.3668 51.8042 17.2994 51.0959C17.2207 50.3426 16.8496 49.7579 16.2088 49.4206C15.0619 48.8135 13.724 48.9371 12.802 49.6904C12.0937 49.1058 11.2055 48.9034 10.2273 49.117C9.51895 49.2744 9.01299 49.5893 8.67569 50.0727C8.48456 50.3426 8.40585 50.6349 8.34963 50.871L8.32715 51.748L8.34963 51.9166C8.41709 52.119 8.47331 52.3102 8.56326 52.5125Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep5);
export default __webpack_public_path__ + "static/media/ww-step5.0275c914.svg";
export { ForwardRef as ReactComponent };